export default __webpack_public_path__ + "static/media/Flowchart example.f8245d93.jpg";